import styled from 'styled-components';

export const CollapsibleStyled = styled.div`
  .title-container {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    .Polaris-Icon {
      margin: 0;
    }
  }
`;
